define(
	'BTM.AutomaticStoreAssignment.AutomaticStoreAssignment', [
		'Location.Collection', 'Location.Model', 'Location', 'ProductDetails.Full.View', 'Cart.Detailed.View', 'SC.Configuration', 'underscore', 'jQuery'
	],
	function (
		LocationCollection, LocationModel, Location, ProductDetailsFullView, CartDetailedView, Configuration, _, jQuery
	) {
		'use strict';

		function searchLocation(data, callBack) {
			try {
				new LocationCollection().fetch().done(function (locations) {
					var searchResult = [];
					_.each(locations.records, function (location) {
						if (data.locationtype) {
							if (location.locationtype == data.locationtype) {
								searchResult.push(location);
							}
						}
					});
					if (callBack) {
						callBack(searchResult);
					}
				});
			} catch (error) {
				if (callBack) {
					callBack(null);
				}
			}
		}

		return {
			mountToApp: function mountToApp(container) {

				if (!Configuration.get('siteSettings.isPickupInStoreEnabled')) {
					return;
				}

				var location_id = getCookie('myStore');
				if (location_id == null || location_id == undefined) {
					searchLocation({
						locationtype: 1 //0: Blank, 1: Store, 2: Warehouse
					}, function (locations) {
						// Set to the first location if there is only one store
						if (locations && locations.length == 1) {
							setCookie('myStore', locations[0].internalid, 365);
						}
					});
				}

				function getCookie(cname) {
					try {
						var name = cname + "=";
						var decodedCookie = decodeURIComponent(document.cookie);
						var ca = decodedCookie.split(';');
						for (var i = 0; i < ca.length; i++) {
							var c = ca[i];
							while (c.charAt(0) == ' ') {
								c = c.substring(1);
							}
							if (c.indexOf(name) == 0) {
								return c.substring(name.length, c.length);
							}
						}
					} catch (ignored) {}
					return null;
				}

				function setCookie(cname, cvalue, exdays) {
					var d = new Date();
					d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
					var expires = "expires=" + d.toUTCString();
					document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
				}

				container.getLayout().on('beforeAppendView', function (view) {
					if (view instanceof ProductDetailsFullView) {

						var location_id = view.model.get('location').get('internalid') || getCookie('myStore');

						if (location_id) {
							Location.fetchLocations(location_id).done(function () {
								view.model.set('location', Location.get(location_id));
							});
						} else {
							searchLocation({
								locationtype: 1 //0: Blank, 1: Store, 2: Warehouse
							}, function (locations) {
								// Set to the first location if there is only one store
								if (locations && locations.length == 1) {
									setCookie('myStore', locations[0].internalid, 365);
									view.model.set('location', locations[0]);
								}
							});
						}
					} else if (view instanceof CartDetailedView) {
						var location_id = getCookie('myStore');
						if (location_id == null || location_id == undefined) {
							searchLocation({
								locationtype: 1 //0: Blank, 1: Store, 2: Warehouse
							}, function (locations) {
								// Set to the first location if there is only one store
								if (locations && locations.length == 1) {
									setCookie('myStore', locations[0].internalid, 365);
								}
							});
						}
					}
				});
			}
		};
	});
